<template>
	<div id ="recibo" class="table-responsive-lg recibo">
		<!-- hoja normal -->
		<div id="hoja">
		<div id="carta"  v-for="index in 4" :key="index" :class="{division : index %2 == 0}">
			    <table>
					<!-- <tr v-if="index==2" :class="{division : index==2}"><td colspan="3">{{'_'}}</td> --><!-- <td>{{'_______'}}</td> --><!-- </tr> --> <!--Descomentar td  de arriba si se mueve-->
			    	<tr>
					<td><img class="logo" src="..\..\..\assets\logo-pj-transparente-negro-recibo.png" alt="logo" ></td>
					<td class="text-center"><h2>H. SUPREMO TRIBUNAL DE JUSTICIA DEL ESTADO <br> DE AGUASCALIENTES</h2><br>
						<h3>RECIBO DE CAJA</h3></td>
						<td style=" width: 22%; text-align: right" class="text-right">
							
							<qr :text="urlVerificar" class="qrhoja" style="margin-left: 50%; margin-right: 50%"></qr><br>
							<h6>Para verificar los datos contenidos en el presente comprobante ingrese a la página: <br>{{urlPJ/* 'https://www.poderjudicialags.gob.mx/' */ + '/Funciones/VerificacionDePagos'}}<br> Su Código de Verificación: {{Recibo.Hash}}</h6>
							<h5>FOLIO: {{Recibo.Folio}}</h5>	
						</td>
					</tr>
				</table>
				<table class="table table-bordered text-center">
					<tr>
						<th style="width: 33%; padding: 5px;">FECHA</th>
						<th style="width: 33%; padding: 5px">JUZGADO</th>
						<th style="width: 33%; padding: 5px">{{Recibo.Expediente.TipoDocumento.Nombre}}</th>
					</tr>
					<tr class="recibo-sub">
						<td>{{FechaDDMMAAAA(Recibo.FechaDePago)}}</td>
						<td>{{Recibo.Expediente.Area.Abreviatura}}</td> <!--O .Nombre-->
						<td>{{(Recibo.Expediente.NumeroRomano == null) ? Recibo.Expediente.Consecutivo : Recibo.Expediente.Consecutivo +"-"+ Recibo.Expediente.NumeroRomano}}</td>
					</tr>
				</table>

				<table class="table text-center">
					<tr v-for="(rubro, indexR) in Pagos" :key="indexR">
						<th v-if="indexR == 0" style=" align-content: center;">NOMBRE</th>
						<td v-if="indexR == 0" colspan="2">{{Imputado.Nombre +" "+
						(Imputado.ApellidoPaterno == null ? "" : Imputado.ApellidoPaterno) +" "+ 
					(Imputado.ApellidoMaterno == null ? "" : Imputado.ApellidoMaterno)}}</td> <!--Mostrar nombre solo 1 vez-->
					</tr>
					<tr><td colspan="3" style="padding-top: 0"></td></tr>
					<tr class="table-bordered" style="width: 100%">
						<th style="width: 50%">CONCEPTO</th>
						<th style="width: 50%">IMPORTE</th>
					</tr>
					<tr  class="recibo-sub table-bordered " v-for="(rubro, indexR) in Pagos"><!--Mostrar conceptos 1 por 1-->
						<td style="width: 50%;">{{rubro.RubroDBPJ.Nombre.toUpperCase()}}</td>
						<td style="width: 50%">{{"$"+agregarCeros(rubro.Monto) }} </td>
					</tr>
				<!-- <tr><td colspan="3">{{""}}</td></tr> -->
					<tr><th>{{"TOTAL "}}</th><th>{{"$"+agregarCeros(total)}}</th></tr>
					<tr><td colspan="2" style="text-align: right; font-family: Helvetica">{{numerosAPalabras(total) + (total == 1 ? ' PESO' : ' PESOS') + ' ' +(total % 1).toFixed(2).substring(2) + '/100 M.N.'}}</td></tr>
					<tr  class="recibo-sub" ><td style=" text-align: end;">{{(index == 1) ? "ORIGINAL" : "COPIA"}}</td><td style=" text-align: end;">{{"Teléfono: " + Recibo.Telefono}}</td></tr>
				</table>
		</div>
		</div>
		<!-- ticket -->
		<div id="ticket" v-for="index in 3" :key="index">
			<table class="table table-borderless text-center">
				<tr class="text-center">
					<td><img class="logo" src="..\..\..\assets\logo-pj-transparente-negro-recibo.png" alt="logo" id="logo"></td>
				</tr>
				<tr>
					<td class="text-center"><h3>H. SUPREMO TRIBUNAL DE JUSTICIA <br> DEL ESTADO DE AGUASCALIENTES</h3>
						<br><h3>RECIBO DE CAJA</h3>
						<br><h3>{{ "FOLIO " + Recibo.Folio}}</h3>
						<br>
					</td>
				</tr>
			</table>

			<table class="table table-borderless text-center">
				<tr v-for="(rubro, indexR) in Pagos" style="border-bottom: 1px solid">
						<th v-if="indexR == 0" style=" align-content: center;">NOMBRE</th>
						<td class="recibo-sub" v-if="indexR == 0" style="text-align: start;">{{Imputado.Nombre +" "+
						(Imputado.ApellidoPaterno == null ? "" : Imputado.ApellidoPaterno) +" "+ 
					(Imputado.ApellidoMaterno == null ? "" : Imputado.ApellidoMaterno)}}</td> <!--Mostrar nombre solo 1 vez-->
				</tr>
				<tr><td colspan="2"><br></td></tr>
				<tr style="width: 100%">
					<th style="text-align: end; width: 50%">CONCEPTO</th>
					<th style="text-align: start; width: 50%">IMPORTE</th>
				</tr>
				<tr  class="recibo-sub" v-for="(rubro, indexR) in Pagos" ><!--Mostrar conceptos 1 por 1-->
					<td style="text-align: end;">{{rubro.RubroDBPJ.Nombre.toUpperCase()}}</td>
					<td style="text-align: start;">{{"$"+agregarCeros(rubro.Monto) }} </td>
				</tr>
				<tr><td colspan="2" style="border-bottom: 1px solid"><br></td></tr>
				<tr><th style="text-align: end;">{{"TOTAL "}}</th><th style="text-align: start;">{{"$"+agregarCeros(total)}}</th></tr>
				<tr><td colspan="2" style="text-align: center; font-family: Helvetica">{{numerosAPalabras(total) + (total == 1 ? ' PESO' : ' PESOS') + ' ' +(total % 1).toFixed(2).substring(2) + '/100 M.N.'}}</td></tr>
				<tr><td colspan="2"><br></td></tr>
			</table>
			<table class="table table-borderless text-center">
					<tr>
						<th>FECHA</th>
						<th>JUZGADO</th>
						<th>{{Recibo.Expediente.TipoDocumento.Nombre}}</th>
					</tr>
					<tr class="recibo-sub">
						<td>{{FechaDDMMAAAA(Recibo.FechaDePago)}}</td>
						<td>{{Recibo.Expediente.Area.Abreviatura}}</td> <!--O .Nombre-->
						<td>{{(Recibo.Expediente.NumeroRomano == null) ? Recibo.Expediente.Consecutivo : Recibo.Expediente.Consecutivo +"-"+ Recibo.Expediente.NumeroRomano}}</td>
					</tr>
					<tr><td></td></tr>
					<tr  class="recibo-sub" ><td></td><td colspan="2" style="text-align: right;">{{"Teléfono: " + Recibo.Telefono}}</td></tr>
					<tr><td></td></tr>
					<tr><td colspan="3"><b>Para verificar los datos contenidos en el presente comprobante ingrese a la página: <br>{{urlPJ/* 'https://www.poderjudicialags.gob.mx/' */ +  '/Funciones/VerificacionDePagos'}}<br> Su Código de Verificación: </b></td></tr>
					<tr><td colspan="3" style=" text-align: center;"> {{Recibo.Hash}} </td></tr>
			</table>
			
			<qr :text="urlVerificar" class="qrticket"></qr>
			<div style="width: 100%; padding-top: 100px;  text-align:center;" class="recibo-sub" v-if="index == 1"><h3>ORIGINAL </h3></div>
			<div style="width: 100%; padding-top: 100px;  text-align:center;" class="recibo-sub" v-else ><h3>COPIA</h3></div>
			<div class="pagebreak" v-if="index < 3"></div>
		</div>
	</div>
</template>



<script>
	import Vue from 'vue'
	import VueHtmlToPaper from 'vue-html-to-paper'
	import api from '@/../static/js/api'
	import axios from 'axios'
	import comun from "@/../static/js/comun"
	import enumeraciones from '@/../static/js/enumeraciones'
	import func from '../Comun/Funciones/comun.js'

	import VueQRCodeComponent from 'vue-qrcode-component'


	Vue.use(VueHtmlToPaper)
	Vue.component('qr', VueQRCodeComponent)

	export default{
		data(){
			return{
				Pagos:null,
				Recibo: {
					Expediente:{
						Area:{},
						TipoDocumento:{}
					},
					FechaDePago:String,
					Hash: ""
				},
				urlVerificar: "",
				urlPJ: "",
				index:  0
			}
		},

	computed: {
		total(){//ir sumando cada monto
			if(this.Pagos){
				return this.Pagos.reduce((sum, Pagos)=>{
					return sum + Pagos.Monto
				}, 0)
			}
		}
	},

	methods:{
	  buscarFolio:function (folio) {//busqueda por folio y nada mas
	  	const parametros = 
	  	{   
	  		Folio: folio == null ? comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null) : folio
	  	}
	  	if(folio > 0 && folio != null){
	  		const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

	  		return axios.post(api.conexion + api.SIVAC.sistema.caja.pagos.BuscarPagos, parametros, headerPeticion)
	  		.then(respuesta => {
	  			if (respuesta.data.SiHayError) {
	  				console.log(respuesta);

	  				this.limpiarTablaResultados();
	  				comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
	  			} else {
              //Cargar Datos de Pagos
              		this.Pagos = respuesta.data.Pagos;		//solo se separo para mejor lectura en la parte de recibo
              		this.Recibo = respuesta.data.Pagos[0];	//
              		this.Imputado = respuesta.data.Pagos[0];			//
              //comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
              		this.urlPJ = window.location.origin;

	  				this.urlVerificar = this.urlPJ + '/Pagos/VerificacionDePagos?qr=' + this.Recibo.Hash

          		}         
      		})
	  		.catch(e => {
	  			comun.SeEstaCargandoInformacion(false);
	  			console.log("No Hay Respuesta del Servidor" + e);
	  			comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
	  		});	
	  	}
	  },

	  async actualizarEstatusImpresion(folio){
	  	this.buscarFolio(folio);
	  	const parametros = {
	  		Impreso : true,
	  		Folio : folio
	  	}
	  	if(folio > 0 && folio != null){
	  		const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false); 

	  		return axios.post(api.conexion + api.SIVAC.sistema.caja.pagos.ActualizarEstatusImpresion, parametros, headerPeticion)
	  			.then(respuesta => {
	  			if (respuesta.data.SiHayError) {
	  				console.log(respuesta);

	  				this.limpiarTablaResultados();
	  				comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
	  			} else {

          		}         
     			})
     			.catch(e => {
	  				comun.SeEstaCargandoInformacion(false);
	  				console.log("No Hay Respuesta del Servidor" + e);
	  				comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
	  			});
	  	}
	  },


	  // async imprimirReciboTermal(){ ///para probar se necesita impresora termal, sin margenes y papel 58(48) x 3276mm
	  	//tamaños que se han visto : 80mm, 58mm, 70 mm, 76mm, 83mm
	  // },

	  async imprimirReciboHoja(folio){
	  	await this.buscarFolio(folio);

	  	setTimeout(() => {
	  		this.$htmlToPaper('recibo', {
	  			name: '_blank',
	  			styles: [
	  				'/static/css/bootstrap.min.css',
	  				'/static/css/recibo.css'
	  			],
  			// timeout: 1000, //no sirven 
  			// autoClose: true, 
  			//windowTitle: window.document.title,
  		}, async ()=>{
  			await this.actualizarEstatusImpresion(folio);
  			if(this.$route.name == 'Pagos'){
  					await this.$parent.getFoliosSinImprimir()
  					this.$parent.buscarImputadoAPI()
  			}
  			if(this.$route.name == 'AltaCaja'){
  					await this.$parent.getFoliosSinImprimir()
  			}
  			});
	  		
		}, 1);//1 ms solo para que cargue el pdf, aumentar si se tarda

	  },

	  imprimirRecibo: function(folio){

	  	this.imprimirReciboHoja(folio);

	  },

	  FechaDDMMAAAA : function(fecha){
	  	return func.FechaDDMMAAAA(fecha)
	  },

	  agregarCeros : function(monto){
	  	return func.agregarCeros(monto)
	  },
	  	
	  numerosAPalabras: function(numero){
	  	return func.numerosAPalabras(numero)
	  },
	}
}



</script>
<style scoped>


// WEBPACK FOOTER //
// src/components/SIVAC/Caja/Recibo.vue